@if (cart$ | async; as cart) {
  @if (entries$ | async; as entries) {
    @if (displayCustomerPrices$ | async) {
      <div class="d-flex flex-column flex-md-row justify-content-end" [ngClass]="{'mb-3' : !cart.fromConfigurator}">
        <div class="d-flex flex-column col-12 col-md-4 p-0">
          <app-efa-order-summary [cart]="cart"></app-efa-order-summary>
          <app-order-shipping-cost-notice [cart]="cart"></app-order-shipping-cost-notice>
        </div>
      </div>
      @if ((isCartContainingEntriesWithExchangeTaxRequired$ | async) && cart.totalExchangeTax && !cart.fromConfigurator) {
        <div class="d-flex justify-content-end mb-3">
          <div class="col-12 col-md-4 p-0">
            <p class="c-cart-tax-notice">
              <sup>*</sup> {{ 'cartAdministration.orderCost.noticeATTax' | cxTranslate }}
            </p>
          </div>
        </div>
      } @else {
        @if (cart.fromConfigurator) {
          <div class="d-flex justify-content-end c-configurator-cart-tax-notice-container">
            <div class="col-12 col-md-4 p-0">
              <p class="c-configurator-cart-tax-notice">
                <sup>*</sup> {{ 'cartAdministration.orderCost.noticeConfiguratorTaxAndDeliveryCosts' | cxTranslate }}
              </p>
            </div>
          </div>
        }
      }
    }
    <div class="d-flex justify-content-end">
      @if (canPlaceOrders$ | async) {
        @if (cart.skipAutomaticCalculation && !cart.calculatedForCheckout && !cart.fromConfigurator) {
          <div class="col-12 col-md-4 p-0">
            @if (entries.length) {
              <button
                class="btn btn-primary btn-block"
                type="button" (click)="calculateCart()">
                {{ 'cartAdministration.cart.calculate' | cxTranslate }}
              </button>
            }
          </div>
        } @else {
          <div class="col-12 col-md-4 p-0">
            @if (entries.length) {
              <button [routerLink]="{ cxRoute: 'checkout' } | cxUrl"
                class="btn btn-primary btn-block"
                type="button" (click)="publishFieldMarks()">
                {{ 'cartDetails.proceedToCheckout' | cxTranslate }}
              </button>
            }
          </div>
        }
      }
    </div>
  }
}

